(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["uvfeel-pdp-enhancements"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('uv-pdp-shortcut')) {
    customElements.define('uv-pdp-shortcut', class extends HTMLElement {
      connectedCallback() {
        const root = this.closest('[data-uv-pdp]');
        const purchase = root?.querySelector('[data-uv-pdp-purchase]');
        const form = root?.querySelector('[data-uv-pdp-form]');
        const button = this.querySelector('button');
        if (!purchase || !form || !button || !('IntersectionObserver' in window)) return;

        this.events = new AbortController();
        const mobile = window.matchMedia('(max-width: 749px)');
        const footer = document.querySelector('footer');
        const update = () => {
          const bounds = purchase.getBoundingClientRect();
          const visible = bounds.bottom > 100 && bounds.top < window.innerHeight;
          const footerVisible = footer && footer.getBoundingClientRect().top < window.innerHeight;
          this.hidden = !mobile.matches || visible || footerVisible;
          button.lastElementChild.textContent = bounds.top > 0 ? '↓' : '↑';
        };
        this.observer = new IntersectionObserver(update, { rootMargin: '-100px 0px 0px' });
        this.observer.observe(purchase);
        if (footer) this.observer.observe(footer);
        mobile.addEventListener('change', update, { signal: this.events.signal });
        button.addEventListener('click', () => {
          const target = root.querySelector('variant-selects') || root.querySelector('.uvfeel-customization') || form;
          const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          target.scrollIntoView({ behavior: reducedMotion ? 'instant' : 'smooth', block: 'start' });
          const focusable = target.querySelector('input:checked, select, input:not([type="hidden"]):not([type="radio"]):not([type="file"]), textarea, button');
          focusable?.focus({ preventScroll: true });
        }, { signal: this.events.signal });
        update();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.events?.abort();
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
